import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const initialValues = {
};

const validationSchema = Yup.object({

});

const activeCase = [
    {
        id: 0,
        title: "غیر فعال"
    }, {
        id: 1,
        title: "فعال"
    }
]



const Update = () => {

    const { addData: addDataService } = useEntityCrud('Service/SetService')
    const { readData: readDataGroup } = useEntityCrud('Group/GetAllGroups')
    const { readDataByFilter: readDataById } = useEntityCrud('Service/GetService');
    const { updateDate: updateDateService } = useEntityCrud('Service/UpdateService');
    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')
    const [activeMode, setActiveMode] = useState("");

    const [businessList, setBusinessList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [activeList, setActiveList] = useState([]);
    const { isEditMode, setIsEditMode } = (true)
    const navigate = useNavigate();
    const { id } = useParams();
    const [orgAddress, setOrgAddress] = useState({
        buisnessId: "",
        groupId: ""
    })

    useEffect(() => {
        const postedData = {
            buisnessId: orgAddress?.buisnessId?.value,
        };
        readDataGroup(postedData).then(res => {
            setGroupList(res.data.result.map(item => ({ value: item.id, label: item.title })))
        });
        setActiveList(activeCase.map(item => ({ value: item.id, label: item.title })))
        readDataBusiness().then(res => {
            setBusinessList(res.data.result)
        });
    }, [])


    useEffect(() => {
        const postedData = {
            "ServiceId": parseInt(id)
        };
        readDataById(postedData).then(res => {
            const data = res.data.result;
            console.log(data);
            setActiveMode(data.isActive)
            formik.setValues({
                ...data,
                title: data.title,
                activeId: { value: data.isActive === true ? 1 : 0, label: data.isActive === 0 ? "غیر فعال" : "  فعال" }
            });
            setOrgAddress({
                groupId: { value: data.groupId }
            })
        });
    }, []);


    const onSubmit = (values) => {
        const postedData = {
            id: id,
            title: values.title,
            deliverType: values.deliverType,
            isActive: activeMode,
            groupId: orgAddress.groupId.value
        };
        updateDateService(postedData).then(res => {
            if (res.status === 200) {
                if (res.data.status === false) {
                    toast.error('متاسفانه سرویس در سیستم ثبت نشد');
                }
                else {
                    navigate("/service");
                    toast.success('سرویس با موفقیت در سیستم ثبت شد');
                }
            } else
                res.data.errors.map(error => toast.error(error.message));
        })
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });




    const handleBack = () => {

        navigate('/service', { replace: true });

    }


    return (
        <div className="card">
            <div className="card-header  d-flex justify-content-between">
                <div className="card-title">
                    ویرایش سرویس</div>
                <a className='backIconLink' onClick={handleBack}> <i className='fa fa-arrow-left'
                    title="بازگشت"> </i> </a>
            </div>
            <div className="card-body">
                <Form formik={formik} groupList={groupList} setGroupList={setGroupList} activeList={activeList}
                    isEditMode={true}
                    businessList={businessList} orgAddress={orgAddress} setOrgAddress={setOrgAddress} />
            </div>
        </div>
    );
}

export default Update;